// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const DeliveryNoDocuments = t.struct({
    customerName: t.maybe(t.String),
    customerNumber: t.maybe(t.String),
    days: t.maybe(t.Number),
    dealerCity: t.maybe(t.String),
    dealerName: t.maybe(t.String),
    deliveryDate: t.maybe(t.Number),
    invoiceDate: t.maybe(t.Number),
    pin: t.maybe(t.String),
    registrationDate: t.maybe(t.Number),
    responsibleDealer: t.maybe(t.String)
}, {
    name: 'DeliveryNoDocuments',
    strict: true
});

export const getDefaultState = () => new DeliveryNoDocuments({
});

export default DeliveryNoDocuments;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/delivery-no-documents.js